import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterHost'
})
export class FilterHostPipe implements PipeTransform {

  transform(hosts: any[], alarmTableFilters: any): unknown {
    return alarmTableFilters && alarmTableFilters.filteredValue && Object.keys(alarmTableFilters.filters).length > 0 ? hosts.filter(host => {
      return !!alarmTableFilters.filteredValue.find(alarm => alarm.hostname === host.hostName)
    }) : hosts;
  }

}
